import { Injectable } from '@angular/core';
import { Observable, forkJoin, of } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import {
  DashboardConfig,
  DashboardWidget
} from './home-dashboard.models';
import { ConfigStorageService } from '../shared/config-storage.service';
import { DataService } from '../shared/data.service';

@Injectable({
  providedIn: 'root'
})
export class HomeDashboardService {

  private dashboardLayout$: Observable<DashboardConfig> | null = null;

  constructor(
    private configStorage: ConfigStorageService,
    private dataService: DataService
  ) {}

  public getDashboardLayout(): Observable<DashboardConfig> {
    if (!this.dashboardLayout$) {
      this.dashboardLayout$ = this.configStorage.getEntity<DashboardConfig>('dashboard', 'main').pipe(
        shareReplay(1)
      );
    }

    return this.dashboardLayout$;
  }

  public getWidgetConfigs(widgetNames: string[]): Observable<{ [name: string]: DashboardWidget }> {
    if (!widgetNames?.length) {
      return of({});
    }

    const queries = widgetNames.reduce((acc, name) => {
      acc[name] = this.configStorage.getEntity<DashboardWidget>('widget', name);
      return acc;
    }, {} as { [name: string]: Observable<DashboardWidget> });

    return forkJoin(queries);
  }

  public executeQuery(procedureName: string, parameters: { [key: string]: any }): Observable<any[]> {
    return this.dataService.execute(procedureName, parameters);
  }

}
